/**

 * Merkzettel System

 * Mit API Sync fuer eingeloggte Kunden und Gaeste.

 */



class Merkzettel {

  constructor() {

    this.storageKey = 'ersatz_merkzettel';

    this.guestIdKey = 'cinebuch_guest_id';

    this.apiUrl = '/apps/indexnow/wishlist';
    this.guestTokenKey = 'cinebuch_wishlist_private_v2';
    this.pendingKey = 'cinebuch_wishlist_pending_v2';
    try { this.pendingAdditions = JSON.parse(localStorage.getItem(this.pendingKey) || '{}'); } catch (_) { this.pendingAdditions = {}; }
    if (!this.pendingAdditions || typeof this.pendingAdditions !== 'object' || Array.isArray(this.pendingAdditions)) this.pendingAdditions = {};
    this.syncChain = Promise.resolve();

    this.items = this.ladeArtikel();

    this.init();

  }



  init() {

    if (document.readyState === 'loading') {

      document.addEventListener('DOMContentLoaded', () => this.setup());

    } else {

      this.setup();

    }

  }



  setup() {

    this.aktualisiereAnzahl();

    this.bindeEvents();

    this.markiereAktiveButtons();



    // Bestehende lokale Merkzettel nach Deploy auch ohne neuen Klick synchronisieren.

    if (this.items.length > 0) {

      this.syncToAPI([], true);

    }

  }



  bindeEvents() {

    document.addEventListener('click', (event) => {

      const button = event.target.closest('[data-merkzettel-btn]');

      if (!button) return;



      event.preventDefault();

      this.toggle(button);

    });

  }



  ladeArtikel() {

    try {

      const data = localStorage.getItem(this.storageKey);

      return data ? JSON.parse(data) : [];

    } catch (error) {

      return [];

    }

  }



  leseGuestId() {

    try {

      const guestId = localStorage.getItem(this.guestIdKey);

      return guestId || null;

    } catch (error) {

      return null;

    }

  }



  holePrivatenSchluessel() {
    if (this.privateKey) return this.privateKey;
    try {
      const saved = localStorage.getItem(this.guestTokenKey);
      if (/^[a-f0-9]{64}$/.test(saved || '')) return (this.privateKey = saved);
    } catch (_) {}
    const bytes = crypto.getRandomValues(new Uint8Array(32));
    this.privateKey = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    try { localStorage.setItem(this.guestTokenKey, this.privateKey); } catch (_) {}
    return this.privateKey;
  }

  parsePreis(value) {

    if (typeof value === 'number') {

      return value;

    }



    const raw = String(value || '').trim();

    if (!raw) {

      return 0;

    }



    const normalized = raw

      .replace(/[^\d,.-]/g, '')

      .replace(/\.(?=\d{3}(?:\D|$))/g, '')

      .replace(',', '.');



    const parsed = Number.parseFloat(normalized);

    return Number.isFinite(parsed) ? parsed : 0;

  }



  bauePayload(items, additionIds, initialImport) {
    return {
      guest_token: this.holePrivatenSchluessel(),
      addition_ids: additionIds,
      initial_import: initialImport,
      items: items.map(item => ({
        shopify_product_id: String(item.id), product_handle: item.handle,
        product_title: item.titel, product_price: this.parsePreis(item.preis) / 100, product_image: item.bild
      }))
    };
  }

  syncToAPI(additionIds = [], initialImport = false) {
    const snapshot = this.items.map(item => ({ ...item }));
    const currentIds = new Set(snapshot.map(item => String(item.id)));
    for (const id of Object.keys(this.pendingAdditions)) {
      if (!currentIds.has(id)) delete this.pendingAdditions[id];
    }
    for (const id of additionIds) this.pendingAdditions[id] = Array.from(crypto.getRandomValues(new Uint8Array(12)), value => value.toString(16).padStart(2, '0')).join('');
    const pendingSnapshot = { ...this.pendingAdditions };
    const savePending = () => { try { localStorage.setItem(this.pendingKey, JSON.stringify(this.pendingAdditions)); } catch (_) {} };
    savePending();
    this.syncChain = this.syncChain.catch(() => {}).then(async () => {
      try {
        const response = await fetch(`${this.apiUrl}/sync`, {
          method: 'POST', credentials: 'same-origin', cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.bauePayload(snapshot, Object.keys(pendingSnapshot), initialImport))
        });
        if (response.ok) {
          for (const [id, nonce] of Object.entries(pendingSnapshot)) {
            if (this.pendingAdditions[id] === nonce) delete this.pendingAdditions[id];
          }
          savePending();
        } else console.warn('Merkzettel-Synchronisierung voruebergehend nicht verfuegbar:', response.status);
      } catch (_) {
        console.warn('Merkzettel bleibt lokal gespeichert; Synchronisierung spaeter erneut.');
      }
    });
    return this.syncChain;
  }

  speichereArtikel(additionIds = []) {

    try {

      localStorage.setItem(this.storageKey, JSON.stringify(this.items));

      this.aktualisiereAnzahl();

      this.markiereAktiveButtons();

      this.syncToAPI(additionIds);

    } catch (error) {

      if (error.name === 'QuotaExceededError') {

        alert('Merkzettel ist voll. Bitte entfernen Sie einige Artikel.');

        this.items.shift();

        this.speichereArtikel();

      } else {

        console.warn('Merkzettel Speicher Fehler:', error);

      }

    }

  }



  toggle(button) {

    const produktId = button.dataset.produktId;

    const index = this.items.findIndex((item) => item.id === produktId);



    if (index > -1) {

      this.items.splice(index, 1);

      button.classList.remove('active');

      button.setAttribute('aria-pressed', 'false');

      this.zeigeBenachrichtigung('Aus Merkzettel entfernt');

    } else {

      const produkt = {

        id: produktId,

        titel: button.dataset.produktTitel,

        handle: button.dataset.produktHandle,

        preis: button.dataset.produktPreis,

        bild: button.dataset.produktBild

      };



      this.items.push(produkt);

      button.classList.add('active');

      button.setAttribute('aria-pressed', 'true');

      this.zeigeBenachrichtigung('Zum Merkzettel hinzugefuegt');

    }



    this.speichereArtikel(index > -1 ? [] : [String(produktId)]);

  }



  markiereAktiveButtons() {

    document.querySelectorAll('[data-merkzettel-btn]').forEach((button) => {

      const produktId = button.dataset.produktId;

      const isInWishlist = this.items.some((item) => item.id === produktId);



      if (isInWishlist) {

        button.classList.add('active');

        button.setAttribute('aria-pressed', 'true');

      } else {

        button.classList.remove('active');

        button.setAttribute('aria-pressed', 'false');

      }

    });

  }



  aktualisiereAnzahl() {

    const counter = document.getElementById('wishlist-count');

    if (!counter) {

      return;

    }



    const anzahl = this.items.length;

    counter.textContent = anzahl;

    counter.classList.toggle('opacity-0', anzahl === 0);

  }



  zeigeBenachrichtigung(nachricht) {

    if (window.themeNotifications) {

      window.themeNotifications.show(nachricht);

    }

  }

}



if (typeof window !== 'undefined') {

  window.merkzettel = new Merkzettel();

}
